import IAABadge from "@/components/IAABadge";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Youtube, Instagram, Facebook } from "lucide-react";
const Footer = () => {
  return <footer className="bg-secondary text-white border-t border-primary/20 py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12">
          {/* IAA Badge & Social Media */}
          <div>
            <h3 className="font-bold text-xl mb-6 text-primary">Accreditation</h3>
            <IAABadge className="mb-6" maxWidth={88} />

            <h3 className="font-bold text-xl mb-4 text-primary">Follow Us</h3>
            <div className="flex gap-4">
              <a href="https://www.youtube.com/channel/UCmuiCa9wC93YC1kY_vzc7lg" target="_blank" rel="noopener noreferrer" className="text-secondary-foreground/90 hover:text-primary transition-colors" aria-label="Follow us on YouTube">
                <Youtube className="w-6 h-6" />
              </a>
              <a href="https://www.instagram.com/ulcworld/" target="_blank" rel="noopener noreferrer" className="text-secondary-foreground/90 hover:text-primary transition-colors" aria-label="Follow us on Instagram">
                <Instagram className="w-6 h-6" />
              </a>
              <a href="https://www.facebook.com/ulcworld" target="_blank" rel="noopener noreferrer" className="text-secondary-foreground/90 hover:text-primary transition-colors" aria-label="Follow us on Facebook">
                <Facebook className="w-6 h-6" />
              </a>
              <a href="https://www.tiktok.com/@ulcworld" target="_blank" rel="noopener noreferrer" className="text-secondary-foreground/90 hover:text-primary transition-colors" aria-label="Follow us on TikTok">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Sri Lanka Office */}
          <div>
            <h3 className="font-bold text-xl mb-6 text-primary">Sri Lanka Office</h3>
            <div className="space-y-4 text-secondary-foreground/90">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-1 text-primary" />
                <span>
                  89, Kesbewa Road,
                  <br />
                  Boralesgamuwa,
                  <br />
                  Colombo
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 flex-shrink-0 text-primary" />
                <span>+94 706 930 830</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 flex-shrink-0 text-primary" />
                <span>+94 112 545 817</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 flex-shrink-0 text-primary" />
                <span>upul@ulcworld.com</span>
              </div>
            </div>
          </div>

          {/* UK Office */}
          <div>
            <h3 className="font-bold text-xl mb-6 text-primary">UK Office</h3>
            <div className="space-y-4 text-secondary-foreground/90">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-1 text-primary" />
                <span>
                  Unit 2A, 2nd Floor, Cavendish House,
                  <br />
                  369 Burnt Oak Broadway, Edgware,
                  <br />
                  Middlesex (HA8 5AW)
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 flex-shrink-0 text-primary" />
                <span>+44 775 361 41 51</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 flex-shrink-0 text-primary" />
                <span>+44 207 018 20 27</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 flex-shrink-0 text-primary" />
                <span>upul@ulcworld.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="pb-8 border-b border-primary/20">
          <div className="flex flex-wrap justify-center gap-6 text-secondary-foreground/90">
            <Link to="/" className="hover:text-primary transition-colors">
              Home
            </Link>
            <Link to="/courses" className="hover:text-primary transition-colors">
              Courses
            </Link>
            <Link to="/immigration-services" className="hover:text-primary transition-colors">
              Immigration Services
            </Link>
            <Link to="/nursing" className="hover:text-primary transition-colors">
              Nursing Pathway
            </Link>
            <Link to="/apply" className="hover:text-primary transition-colors">
              Apply Now
            </Link>
            <Link to="/about" className="hover:text-primary transition-colors">
              About Us
            </Link>
            <Link to="/contact" className="hover:text-primary transition-colors">
              Contact
            </Link>
            <Link to="/news" className="hover:text-primary transition-colors">
              News
            </Link>
            <Link to="/careers" className="hover:text-primary transition-colors">
              Careers
            </Link>
            <Link to="/login" className="hover:text-primary transition-colors">
              Student Login
            </Link>
          </div>
        </div>

        <div className="pt-8 text-center">
          <p className="text-secondary-foreground/80">
            &copy; {new Date().getFullYear()} ULC World Education & Migration. All rights reserved.
          </p>
          <div className="flex justify-center gap-4 mt-4">
            <Link to="/privacy" className="text-secondary-foreground/80 hover:text-primary transition-colors text-sm">
              Privacy Policy
            </Link>
            <span className="text-secondary-foreground/40">|</span>
            <Link to="/terms" className="text-secondary-foreground/80 hover:text-primary transition-colors text-sm">
              Terms of Service
            </Link>
          </div>
          <p className="text-secondary-foreground/50 text-xs mt-4">
            This site is protected by reCAPTCHA and the Google{" "}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
              Privacy Policy
            </a>{" "}
            and{" "}
            <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
              Terms of Service
            </a>{" "}
            apply.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;